import { ListStateIconSuccess } from "source/components/framework/List/ListStateIconSuccess";
import { Tooltip } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppButton, IAppButtonProps } from "ui/Scripts/source/components/framework/Button/AppButton";

type PublishButtonProps = IAppButtonProps & {
    published?: boolean;
    modifiedAfterPublish?: boolean;
};

export const PublishButton = (props: PublishButtonProps) => {
    const { published, modifiedAfterPublish, ...rest } = props;

    return (
        <Tooltip title={Translations.Publish}>
            <AppButton
                variant="outlined"
                size="small"
                endIcon={<ListStateIconSuccess color={published ? (modifiedAfterPublish ? "warning" : "success") : "default"} />}
                {...rest}
            >
                {Translations.Publish}
            </AppButton>
        </Tooltip>
    );
};
